import React from 'react'

const EntertainmentHeaderIconWhite = ({ className, size = 32 }) => {
  return (
    <svg 
      className={className}
      width={size} 
      height={size} 
      viewBox="0 0 32 32" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <filter id="white-glow-entertainment">
          <feGaussianBlur stdDeviation="2" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      <circle cx="16" cy="16" r="10" stroke="#ffffff" strokeWidth="2" filter="url(#white-glow-entertainment)"/>
      <circle cx="16" cy="16" r="5" stroke="#ffffff" strokeWidth="2" filter="url(#white-glow-entertainment)"/>
      
      <circle cx="16" cy="6" r="1.5" fill="#ffffff"/>
      <circle cx="16" cy="26" r="1.5" fill="#ffffff"/>
      <circle cx="6" cy="16" r="1.5" fill="#ffffff"/>
      <circle cx="26" cy="16" r="1.5" fill="#ffffff"/>
      
      <circle cx="10" cy="10" r="1.2" fill="#ffffff" opacity="0.8"/>
      <circle cx="22" cy="10" r="1.2" fill="#ffffff" opacity="0.8"/>
      <circle cx="10" cy="22" r="1.2" fill="#ffffff" opacity="0.8"/>
      <circle cx="22" cy="22" r="1.2" fill="#ffffff" opacity="0.8"/>
      
      <path d="M14 13L20 16L14 19V13Z" fill="#ffffff" opacity="0.9"/>
      
      <rect x="2" y="14" width="3" height="4" rx="0.5" fill="#ffffff" opacity="0.4"/>
      <rect x="27" y="14" width="3" height="4" rx="0.5" fill="#ffffff" opacity="0.4"/>
      
      <path d="M26 6L26.5 7L27 6.5L26.5 6L26 5L25.5 6L26 6.5L26.5 7L26 6Z" fill="#ffffff" opacity="0.7"/>
      <path d="M6 26L6.5 27L7 26.5L6.5 26L6 25L5.5 26L6 26.5L6.5 27L6 26Z" fill="#ffffff" opacity="0.7"/>
    </svg>
  )
}

export default EntertainmentHeaderIconWhite
